import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';

import App from '../App';
import Login from '../Login';
import ForgotPassword from '../ForgotPassword';
import ApiDocumentationIframe from '../ApiDocumentation/ApiDocumentationIframe';

import { observer, inject } from 'mobx-react';

@inject('authStore')
@observer
class RouterAuth extends Component {
  render() {
    const { isLoggedIn } = this.props.authStore;
    return (
      <Router>
        <Switch>
          <Route path="/logout" component={Login} />
          <Route path="/login" component={Login} />
          <Route path="/forgot-password" component={ForgotPassword} />
          <Route path="/api-documentation" component={ApiDocumentationIframe} />
          <Route path="/" render={() => (isLoggedIn ? <App /> : <Redirect to="/login" />)} />
        </Switch>
      </Router>
    );
  }
}

export default RouterAuth;



// WEBPACK FOOTER //
// ./src/components/RouterAuth/RouterAuth.js